import React, { useState } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

export const EditInterview = ({
  questions,
  setQuestions,
  person1,
  person2,
}) => {
  const [currentQuestion, setCurrentQuestion] = useState('');
  const [currentAnswer, setCurrentAnswer] = useState('');
  const [selectedPerson, setSelectedPerson] = useState('');
  const [editMode, setEditMode] = useState(null);

  const handleQuestionChange = (e) => {
    setCurrentQuestion(e.target.value);
  };

  const handleAnswerChange = (e) => {
    setCurrentAnswer(e.target.value);
  };

  const handlePersonChange = (e) => {
    setSelectedPerson(e.target.value);
  };

  const handleAddQuestion = () => {
    if (currentQuestion && currentAnswer && selectedPerson) {
      const newQuestion = {
        question: currentQuestion,
        answer: currentAnswer,
        personId: selectedPerson,
      };

      setQuestions([...questions, newQuestion]);
      setCurrentQuestion('');
      setCurrentAnswer('');
      setSelectedPerson('');
    }
  };

  const handleEditQuestion = (index) => {
    setEditMode(index);
    setCurrentQuestion(questions[index].question);
    setCurrentAnswer(questions[index].answer);
    setSelectedPerson(questions[index].personId);
  };

  const handleUpdateQuestion = () => {
    if (currentQuestion && currentAnswer && selectedPerson && editMode !== null) {
      const updatedQuestions = [...questions];
      updatedQuestions[editMode] = {
        question: currentQuestion,
        answer: currentAnswer,
        personId: selectedPerson,
      };

      setQuestions(updatedQuestions);
      setEditMode(null);
      setCurrentQuestion('');
      setCurrentAnswer('');
      setSelectedPerson('');
    }
  };

  const handleRemoveQuestion = (index) => {
    const updatedQuestions = [...questions];
    updatedQuestions.splice(index, 1);
    setQuestions(updatedQuestions);
  };

  return (
    <Stack spacing={2}>
      {questions.map((q, index) => (
        <Box
          key={index}
          sx={{
            border: '1px solid rgba(0,0,0,0.14)',
            borderRadius: 2,
            p: 1.5,
            bgcolor: 'rgba(0,0,0,0.02)',
          }}
        >
          <Typography variant="subtitle1" fontWeight={700}>Question {index + 1}</Typography>
          <Typography variant="body2" sx={{ mt: 0.5, wordBreak: 'break-word' }}>Question: {q.question}</Typography>
          <Typography variant="body2" sx={{ mt: 0.5, wordBreak: 'break-word' }}>Answer: {q.answer}</Typography>
          <Typography variant="body2" sx={{ mt: 0.5 }}>
            Person: {q.personId === person1._id ? person1.name : person2.name}
          </Typography>
          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} sx={{ mt: 1.5 }}>
            <Button variant="outlined" onClick={() => handleEditQuestion(index)} fullWidth>
              Edit Question
            </Button>
            <Button variant="outlined" color="error" onClick={() => handleRemoveQuestion(index)} fullWidth>
              Remove Question
            </Button>
          </Stack>
        </Box>
      ))}

      <TextField
        label="Interview Question"
        variant="outlined"
        fullWidth
        margin="normal"
        value={currentQuestion}
        onChange={handleQuestionChange}
      />

      <TextField
        label="Answer"
        variant="outlined"
        fullWidth
        multiline
        rows={4}
        margin="normal"
        value={currentAnswer}
        onChange={handleAnswerChange}
      />

      <Select
        displayEmpty
        label="Person Answering"
        variant="outlined"
        fullWidth
        value={selectedPerson}
        onChange={handlePersonChange}
      >
        <MenuItem value="" disabled>Person Answering</MenuItem>
        <MenuItem value={person1._id}>{person1.name}</MenuItem>
        <MenuItem value={person2._id}>{person2.name}</MenuItem>
      </Select>

      {editMode !== null ? (
        <Button variant="contained" color="primary" onClick={handleUpdateQuestion} fullWidth>
          Update Question
        </Button>
      ) : (
        <Button variant="contained" color="primary" onClick={handleAddQuestion} fullWidth>
          Add Question
        </Button>
      )}
    </Stack>
  );
};
